import { Expression } from './Expression.js';
export class PreExpression extends Expression {
    constructor(value) {
        super();
        this.value = value;
    }
    getValue() {
        return this.value;
    }
    evaluate(visitor, localVariables) {
        return this.getValue().evaluate(visitor, localVariables);
    }
}
//# sourceMappingURL=PreExpression.js.map